import { render } from "./PosVe.vue?vue&type=template&id=4196f999&scoped=true"
import script from "./PosVe.vue?vue&type=script&lang=js"
export * from "./PosVe.vue?vue&type=script&lang=js"

import "./PosVe.vue?vue&type=style&index=0&id=4196f999&scoped=true&lang=css"

import exportComponent from "/home/dyam/Documentos/MISTOCK/mi-stock/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4196f999"]])

export default __exports__